export default __webpack_public_path__ + "static/media/ChallengeRankFirst.82aad1b4.svg";